export default {
  title: "Patient Record",
  systemIdTooltip: "Patient System ID",
  copySystemId: "Copy system ID",
  actions: {
    refresh: "Refresh",
  },
  tabs: {
    visits: "Visits",
    tests: "Tests",
  },
  visits: {
    empty: "No visits found for this patient.",
    emptySubtitle: "This patient has no recorded visits.",
    idTooltip: "Visit identifier",
    dateTooltip: "Date and time of the visit",
  },
  tests: {
    empty: "No tests found for this patient.",
    emptySubtitle: "This patient has no recorded tests.",
    viewHistory: "View test history",
    dateTooltip: "Date and time of the latest result",
  },
  errors: {
    patientNotFound: "Patient not found",
    failedToLoad: "Failed to load patient data",
    // Patient info card error states
    patientServerTitle: "Something went wrong",
    patientServerSubtitle: "Failed to load patient info. Please try again.",
    patientNetworkTitle: "Connection lost",
    patientNetworkSubtitle: "Unable to reach the server. Check your connection.",
    patientTimeoutTitle: "Request timed out",
    patientTimeoutSubtitle: "The server is taking too long. Please try again.",
    patientAuthTitle: "Session expired",
    patientAuthSubtitle: "Please log in again to continue.",
    patientUnknownTitle: "Unexpected error",
    patientUnknownSubtitle: "Something went wrong. Please try again later.",
    // Visits table error states
    visitsServerTitle: "Something went wrong",
    visitsServerSubtitle: "Failed to load visits. Please try again.",
    visitsNetworkTitle: "Connection lost",
    visitsNetworkSubtitle: "Unable to reach the server. Check your connection.",
    visitsTimeoutTitle: "Request timed out",
    visitsTimeoutSubtitle: "The server is taking too long. Please try again.",
    visitsAuthTitle: "Session expired",
    visitsAuthSubtitle: "Please log in again to continue.",
    visitsUnknownTitle: "Unexpected error",
    visitsUnknownSubtitle: "Something went wrong. Please try again later.",
    // Tests table error states
    testsServerTitle: "Something went wrong",
    testsServerSubtitle: "Failed to load tests. Please try again.",
    testsNetworkTitle: "Connection lost",
    testsNetworkSubtitle: "Unable to reach the server. Check your connection.",
    testsTimeoutTitle: "Request timed out",
    testsTimeoutSubtitle: "The server is taking too long. Please try again.",
    testsAuthTitle: "Session expired",
    testsAuthSubtitle: "Please log in again to continue.",
    testsUnknownTitle: "Unexpected error",
    testsUnknownSubtitle: "Something went wrong. Please try again later.",
    retry: "Try again",
    login: "Log in",
  },
};
